module.exports = __webpack_public_path__ + "static/img/icon-lazada.1ee7a16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/btn_marketplace/icon-lazada.svg
// module id = wSrv
// module chunks = 134